import i18next from 'i18next';
import { Company } from 'src/store/models/Company';

export const getCompanyName = (company: Company): string => {
  return `${company?.title} ${
    company?.base ? `(${i18next.t('common:internal').toLowerCase()})` : ''
  }`;
};
